<template>
  <div class="box7">
    <pageTitle
      title="实力雄厚的AI应用课程研发团队"
      text="源源不断引进大厂技术大牛，专业研发课程升级，迭<br/>代，与企业需求实时接轨"
    />

    <div class="teacher-box" @scroll="handleScroll">
      <div class="box1" ref="content">
        <div
          class="teacher"
          v-for="(item, index) in teacherList.slice(0, 5)"
          :key="index"
          :style="
            `backgroundImage: url(`+item.image+`)`
          "
          @click="changeCur(index)"
        >
          <div class="tName">{{ item.name }}</div>
          <div class="tagList">
            <p>
              <span v-for="(item1, index1) in item.tag" :key="index1"
                >{{ item1 }}
                <span v-show="index1 != item.tag.length - 1">| </span>
              </span>
            </p>
          </div>
        </div>
        <div class="seat"></div>
      </div>
      <div class="box2">
        <div
          class="teacher"
          v-for="(item, index) in teacherList.slice(5,10)"
          :key="`${index}1`"
          :style="
           `backgroundImage: url(`+item.image+`)`
          "
          @click="changeCur(index, 1)"
        >
          <div class="tName">{{ item.name }}</div>
          <div class="tagList">
            <p>
              <span v-for="(item1, index1) in item.tag" :key="index1"
                >{{ item1 }}
                <span v-show="index1 != item.tag.length - 1">| </span>
              </span>
            </p>
          </div>
        </div>
        <div class="seat"></div>
      </div>
      <!-- <div class="scorll-box">
        <div class="scorll-block" :style="styleVar"></div>
      </div> -->
    </div>

    <van-popup v-model="show" position="bottom" round>
      <div class="pop">
        <div class="pop-top">
          <div class="title">{{ teacherList[this.cur].name }}</div>

          <div class="close" @click="show = false"></div>
        </div>

        <div class="tag-box">
          <div
            class="tag"
            v-for="(item, index) in teacherList[this.cur].tag"
            :key="index"
            :class="'tag' + (index + 1)"
          >
            {{ item }}
          </div>
        </div>

        <p
          v-for="(j, index1) in teacherList[this.cur].result"
          :key="index1"
          :class="{ word: cur == 2 && index1 == 0 }"
        >
          <span></span>
          {{ j }}
        </p>
        <div class="con">
          <b v-for="(j, index1) in teacherList[this.cur].info"
          :key="index1">{{j}}</b>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {
      cur: 0,
      show: false,

      teacherList: [
        {
          name: "阿玮老师",
          tag: ["传智研究院研究员", "8年项目研发与教学经验"],
          result: [
            "《2022Java零基础从入门到起飞》，各平台播放总量近3000万次，最高单日播放学习人次达40000+，B站Java基础课日播榜一。", 
            "《C语言考研，嵌入式，计算机二级一套通关》，各平台播放总量近400万次。"
          ],
          info: [
            "曾任职于中国移动、平安保险。",
            "精通Java EE体系、MySQL、Android、鸿蒙等技术。",
            "主导研发《Java+AI》（基础篇，WEB篇）、《三天从0带你写一个Java小游戏》、《Java从入门到起飞》、《鸿蒙应用开发》等多套课程。",
          ],
          image: require("../../../assets/coursePage/java/box7/awei.png"),
         
        },
        {
          name: "于老师",
          tag: ["传智研究院研究员", "13年开发经验"],
          result: [
            "研发《黑马头条》、《面试专题》、《中州养老》、《若依专题》等课程。", 
            "《面试专题》B站面试课程榜一。",
            "研发课程已累计影响5万+学员，课程播放量超过300万+。"
          ],
          info: [
            "曾先后在360、亚信、众信旅游担任软件工程师、技术经理等职位。",
            "对Springboot、Spring Cloud 、Redis、MySQL等技术积累了丰富的实践经验和教学经验。",
          ],
          image: require("../../../assets/coursePage/java/box7/yu.png"),
         
        },
         {
          name: "邓老师",
          tag: ["传智研究院研究员", "10多年项目研发与教学经验"],
          result: [
            "《MySQL数据库入门到精通》、《JavaWeb开发》、《AI+Web开发》、《零代码带你搞定项目开发与部署-DeepSeek+Cursor+Devbox》等精品课程在B站长期霸榜B站榜一，B站累计播放超2000W。", 
          ],
          info: [
            "曾任汇丰银行研发工程师，曾负责汇丰银行E&M全球业务的改造升级。",
            "精通JavaEE体系、AJax、MySQL、Redis、SpringBoot、SpringCloud、MQ等技术及分布式解决方案有深入研究。",
          ],
          image: require("../../../assets/coursePage/java/box7/deng.png"),
        
        },
         {
          name: "陈老师",
          tag: ["传智研究院研究员", "11年项目研发与教学经验"],
          result: [
            "《JavaWeb从入门到项目实战》各平台播放量超过600万次，B站JavaWeb课程榜一。", 
            "研发课程已累计影响8万+线下学员，750万+互联网学员。"
          ],
          info: [
            "曾任宜信工程师，中融民信技术经理。",
            "专注于分布式、高可用、高性能、微服务架构的设计。精通Java技术栈、对SpringBoot、Redis、ElasticSearch、RabbitMQ、Docker、SpringCloud等有深入研究。",
          ],
          image: require("../../../assets/coursePage/java/box7/chen.png"),
         
        },
         {
          name: "郭老师",
          tag: ["传智高级讲师", "9年项目研发与教学经验"],
          result: [
            "研发K8S入门到精通、SpringCloudalibaba入门到精通、SpringData合集等课程。", 
          ],
          info: [
            "曾在北京航天四创、中科软等单位担任研发经理职务。",
            "曾主持参与浙江省机要系统、国家电网系统、济宁市医疗平台、中国电信网络规划平台、人民日报社扶贫APP的设计开发工作。",
            "精通分布式、微服务、高并发、高可用场景下的各种解决方案。",
          ],
          image: require("../../../assets/coursePage/java/box7/guo.png"),
        },
       
        {
          name: "郝老师",
          tag: ["传智高级讲师", "10年软件开发教学经验"],
          result: [
            "《一套超哇塞的Java教程》《JavaSE入门开发游戏》 B站多套百万播放课程研发者。", 
          ],
          info: [
            "Android、Java方向软件高级开发工程师；研发项目涉及教育、新闻、娱乐直播等。",
            "授课风格幽默风趣，深入浅出，广受学员好评。",
          ],
          image: require("../../../assets/coursePage/java/box7/hao.png"),
        
        },
       
        {
          name: "张老师",
          tag: ["传智研究院研究员", "8年项目研发与教学经验"],
          result: [
            "《Redis入门到实战教程》，B站播放量近400万，Redis关键字排名第一。", 
            "《SpringCloud微服务课程》2部，B站累计播放量近600万。",
            "《SpringAI大模型应用开发》，是B站最早的SpringAI实战课程，SpringAI关键字排名第一。"
          ],
          info: [
            "曾任职于51offer留学、老师来了家教等平台，担任研发主管等职务。",
            "不断深耕AI前沿技术，熟悉SpringAI、SpringAIAlibaba等大模型开发技术，对ToolCalling、RAG、MCP等AI技术都有深入研究。",
          ],
          image: require("../../../assets/coursePage/java/box7/zhang.png"),
          
        },
       
        {
          name: "于老师",
          tag: ["博学谷课程研究员", "8年项目研发与教学经验"],
          result: [
            "《AI+若依》是 B 站首个创新性地基于低代码平台与 AI 技术深度融合的实战IoT物联网项目课程，专题排名第一。", 
          ],
          info: [
            "曾任职于中国移动、一脉阳光。",
            "主导博学谷JavaEE课程多次版本升级（V14.0至V16.0）。",
            "对SpringBoot、SpringCloud、MySQL 、MybatiPlus、Redis、MQ中间件等技术积累了丰富的实践经验和教学经验。",
          ],
          image: require("../../../assets/coursePage/java/box7/yu2.png"),
         
        },
       
        {
          name: "杨老师",
          tag: ["传智高级讲师", "9年项目研发与教学经验"],
          result: ["博学谷中州养老项目录制者，传智大同大学授课老师。"],
          info: [
            "武汉理工计算机和武汉大学经济学双学位，在Java和大数据开发领域有丰富的经验。",
            "曾参与铁路12306数据中台、用户画像、正晚点预测等多个系统的研发工作。"
          ],
          image: require("../../../assets/coursePage/java/box7/yang.png"),
        },
      ],

      scroll: 0,
    };
  },
  computed: {
    styleVar() {
      return {
        "--box-left": this.scroll + "px",
      };
    },
  },
  methods: {
    handleScroll() {
      let dom = this.$refs.content.getBoundingClientRect();
      let left = Math.abs(parseInt(dom.x)) / 30;
      if (left >= 1) {
        this.scroll = left;
      } else {
        this.scroll = 0;
      }
    },
    changeCur(index, num) {
      this.show = true;
      if (num == 1) {
        this.cur = index + 5;
      } else {
        this.cur = index;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.box7 {
  padding: 80px 0 58px;

  width: 100%;
  background: url("../../../assets/coursePage/java/box7/bgc.png") no-repeat;
  background-size: cover;

  .word {
    // white-space: nowrap;
  }
  .teacher-box::-webkit-scrollbar {
    display: none;
    width: 0 !important;
    height: 0 !important;
    color: transparent;
  }
  .teacher-box {
    margin: 46px auto 0;
    width: 100%;
    overflow-x: auto;
    .box1,
    .box2 {
      display: flex;
      .seat {
        width: 32px;
        flex-shrink: 0;
      }
    }
    .scorll-box {
      position: absolute;
      left: 50%;

      transform: translate(-50%, 0px);
      width: 77px;
      height: 6px;
      background: rgba(75, 132, 250, 0.16);
      border-radius: 3px;
      .scorll-block {
        position: absolute;
        left: var(--box-left);
        width: 20px;
        height: 6px;
        background: #4b84fa;
        border-radius: 3px;
      }
    }
    .teacher {
      flex-shrink: 0;
      margin-bottom: 30px;
      padding-left: 26px;
      margin-left: 30px;
      width: 314px;
      height: 394px;
      background-size: cover;
      background-repeat: no-repeat;
      box-sizing: border-box;
      color: #fff;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .tName {
        margin-top: 276px;
        font-size: 28px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: #ffffff;
        line-height: 40px;
      }
      .tagList {
        p {
          width: 270px;
          margin-top: 4px;
          font-size: 22px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #ffffff;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          span {
            line-height: 28px;
          }
        }
      }
    }
  }

  .pop {
    padding: 48px 48px 58px 48px;
    min-height: 844px;
    box-sizing: border-box;
    overflow-y: auto;
    box-sizing: border-box;
    .pop-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: px;
      .title {
        font-size: 36px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #1d2129;
        line-height: 52px;
      }
    }
    .close {
      width: 32px;
      height: 32px;
      background: url("../../../assets/coursePage/ai/box8/close.png") no-repeat;
      background-size: cover;
    }

    .tag-box {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 32px;
      margin-top: 16px;
    }

    .tag {
      margin-right: 16px;
      padding: 0px 16px;
      height: 44px;
      text-align: center;
      line-height: 44px;
      background: #e8f3ff;
      border-radius: 8px;
      margin-top: 16px;
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #165dff;
    }

    .tag2 {
      height: 44px;
      background: #fff7e8;
      border-radius: 8px;

      color: #ff7d00;
    }

    p {
      position: relative;
      // display: flex;
      margin-bottom: 16px;
      padding-left: 24px;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #141D2A;
      line-height: 44px;

      span {
        position: absolute;
        top: 16px;
        left: 0px;
        margin-right: 16px;
        min-width: 8px;
        height: 8px;
        background: #507AEF;
        border-radius: 50%;
      }
    }
    .con{
      margin-top: 16px;
      padding-left: 16px;
      b{
        display: block;
        font-family: PingFangSC, PingFang SC;
font-weight: 400;
font-size: 26px;
color: #4E5969;
line-height: 44px;
text-align: left;
font-style: normal;
      }
    }
  }
}
</style>
